import {TileSize} from 'quickstart/components/tizra/MetaTile'
import {
  ImageCropping,
  ImageFocus,
  SlotConfig,
  SlotName,
} from 'quickstart/components/tizra/MetaTile/common'
import {UseSearchReturn} from 'quickstart/hooks'
import {ComponentType, lazy, Suspense} from 'react'
import {logger, MetaObject} from 'tizra'

const CardsGallery = lazy(() =>
  import('./galleries/cards').then(m => ({default: m.CardsGallery})),
)
const DigestsGallery = lazy(() =>
  import('./galleries/digests').then(m => ({default: m.DigestsGallery})),
)
const HeadlineGallery = lazy(() =>
  import('./galleries/headline').then(m => ({default: m.HeadlineGallery})),
)
const ListGallery = lazy(() =>
  import('./galleries/list').then(m => ({default: m.ListGallery})),
)
const TilesGallery = lazy(() =>
  import('./galleries/tiles').then(m => ({default: m.TilesGallery})),
)
const TitlesGallery = lazy(() =>
  import('./galleries/titles').then(m => ({default: m.TitlesGallery})),
)

const log = logger('BrowseGallery')

type Display = 'cards' | 'digests' | 'list' | 'headline' | 'titles' | 'tiles'

export type BrowseGalleryProps = {
  display: Display
  search: UseSearchReturn<MetaObject>
  maxItems?: number
  size?: TileSize
  slots?: {[k in SlotName]?: SlotConfig}
  background?: string
  foreground?: string
  linkColor?: string
  twoColumnHeadline?: boolean
  imageCropping?: ImageCropping
  imageFocus?: ImageFocus
}

const displayGalleries = {
  cards: CardsGallery,
  digests: DigestsGallery,
  headline: HeadlineGallery,
  list: ListGallery, // TODO: seems disused
  titles: TitlesGallery,
  tiles: TilesGallery,
} as const satisfies {[k in Display]: ComponentType<BrowseGalleryProps>}

export const BrowseGallery = (props: BrowseGalleryProps) => {
  let GalleryComponent = displayGalleries[props.display]

  if (!GalleryComponent) {
    log.error(`unknown display: ${props.display}`)
    GalleryComponent = CardsGallery
  }

  return (
    <Suspense fallback={null}>
      <GalleryComponent {...props} />
    </Suspense>
  )
}
